import { render, staticRenderFns } from "./staging.vue?vue&type=template&id=57d37d06&scoped=true&"
import script from "./staging.vue?vue&type=script&lang=js&"
export * from "./staging.vue?vue&type=script&lang=js&"
import style0 from "./staging.vue?vue&type=style&index=0&id=57d37d06&prod&lang=scss&scoped=true&"
import style1 from "./staging.vue?vue&type=style&index=1&id=57d37d06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d37d06",
  null
  
)

export default component.exports